import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/generics/services/auth.service";
import { UserService } from "src/app/user-management/services/user.service";

@Component({
  selector: "app-modal-password",
  templateUrl: "./modal-password.component.html",
})
export class ModalPasswordComponent implements OnInit {
  passwordMatch: Boolean = true;
  formPassword: FormGroup;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ModalPasswordComponent>,
    private userService: UserService,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.formPassword = this.formBuilder.group({
      id: ["", Validators.required],
      password: [null, [Validators.required]],
      passwordConfirm: [null, [Validators.required]],
    });
    this.initData();
  }

  async initData() {
    this.authService.currentUserSubs.subscribe((user) => {
      this.formPassword.patchValue({ id: user.id });
    });
  }

  async formPasswordSubmit() {
    try {
      this.passwordMatch =
        this.formPassword.controls["password"].value ==
        this.formPassword.controls["passwordConfirm"].value;
      if (this.formPassword.valid && this.passwordMatch) {
        let data = await this.userService
          .changePassword(this.formPassword.value)
          .toPromise();
        this.onNoClick();
      }
    } catch (error) {}
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
